<template>
  <div>
    <el-header class="header" v-show='showOrderList && $route.path !== "/chat"'>
      <h3 class="title">
        <div class="block">
          <span>工单列表</span>
        </div>
      </h3>
    </el-header>
    <el-container  v-show='showOrderList'>
      <el-row class="work-bfb">
        <el-table :data="orders" :header-cell-style="{background:'#f5f5f5',height:'',borderRight: '1px solid #fff',textAlign:'center'}">
          <el-table-column align="center" prop="id" label="工单号" v-if="$route.path !=='/chat'"></el-table-column>
          <el-table-column align="center" prop="name" label="工单名称"></el-table-column>
          <el-table-column align="center" prop="templateName" label="模板" v-if="$route.path !=='/chat'"></el-table-column>
          <el-table-column align="center" prop="creator" label="创建人" v-if="$route.path !=='/chat'"></el-table-column>
          <el-table-column align="center" prop="assignee" label="被指派人" v-if=' this.orderType == 1 && $route.path !=="/chat"' ></el-table-column>
          <el-table-column align="center" prop="createTime" label="创建时间" width="160" :formatter='formatTime'></el-table-column>
          <el-table-column align="center" prop="status" label="状态" width="80" v-if='$route.path === "/chat"' :formatter='formatStatus'></el-table-column>
          <el-table-column align="center" prop="updateTime" label="状态更新时间" width="160" v-if="$route.path !=='/chat'"></el-table-column>
          <el-table-column align="center" prop="" label="操作" width="80">
            <template v-slot="scope">
              <el-tooltip class="item" effect="light" content="查看" placement="bottom">
                <el-button @click="viewOrder(scope)" type="text">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#iconxiangqing" />
                  </svg>
                </el-button>
              </el-tooltip>
              <!--<el-button style="padding: 0%;" @click="viewOrder(scope)" type="text" size="small">查看</el-button>-->
              <el-button style="padding: 0%;" @click="replyOrder(scope)" type="text" size="small" v-if='$route.path === "/chat" && scope.row.status < 2'>回复</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="work-mt20 work-mb20"
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.limit"
          layout="total, prev, pager, next, jumper"
          :total="form.total"
        ></el-pagination>
      </el-row>
    </el-container>
    <Order v-if='showOrderPage' :pageName="'查看工单'" v-on="{goBack: hideOrderPage,getOrders: getOrders}"/>
  </div>
</template>

<script>
import Order from './Order'
export default {
  name: 'OrderList',
  components: { Order },
  data() {
    return {
      orderType: '',
      activeName: 0,
      form: {
        page: 1,
        limit: 10,
        total: 0
      },
      orders: [],
      showOrderList: true,
      showOrderPage: false
    }
  },
  props: [],
  mounted() {
    this.getOrders()
  },
  activated() {
    this.$store.commit('order/saveWidgetOrderUtils', { showTemplates: true, showOrders: false })
    this.getOrders()
  },
  watch: {

  },
  methods: {
    viewOrder(scope) {
      var order = scope.row
      // order.linkedSessions = []
      this.getOrder(order.id)
    },
    replyOrder(scope) {
      const that = this
      const params = {
        id: scope.row.id,
        status: 2
      }
      this.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/updateStatus', { data: null, params }).then(function(response) {
        that.getOrders()
      }).catch(function(error) {
        this.$message.error(error)
      })
    },
    handleCurrentChange(page) {
      this.form.page = page
      this.getOrders()
    },
    handleSizeChange(size) {
      this.size = size
    },
    getOrder(orderId) {
      this.$http.get(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/get?orderId=' + orderId).then(res => {
        this.order = res.data.data
        this.$store.commit('order/saveOrder', this.order)
        this.showOrderList = false
        this.showOrderPage = true
      })
    },
    getOrders() {
      this.showOrderPage = false
      const path = this.$route.path
      if (path.indexOf('processed') > -1) {
        this.orderType = 0
      } else if (path.indexOf('processing') > -1) {
        this.orderType = 1
      } else if (path.indexOf('replied') > -1) {
        this.orderType = 2
      } else if (path.indexOf('finished') > -1) {
        this.orderType = 3
      } else {
        this.orderType = ''
      }
      const params = {
        customerId: this.$route.path === '/chat' ? this.$store.state.crm.customer.id : undefined,
        type: this.orderType,
        page: this.form.page,
        limit: this.form.limit
      }

      this.$http.get(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/list', { params }).then(res => {
        if (res.data.code === 2000) {
          this.orders = res.data.data.list
          this.form.total = res.data.data.total
          if (this.orders.length === 0) {
            this.$store.commit('order/saveWidgetOrderUtils', { showTemplates: true, showOrders: false })
          } else {
            this.$store.commit('order/saveWidgetOrderUtils', { showTemplates: false, showOrders: true })
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    formatStatus(row, column, cellValue, index) {
      if (cellValue === 0) {
        return '未受理'
      } else if (cellValue === 1) {
        return '受理中'
      } else if (cellValue === 2) {
        return '已回复'
      } else if (cellValue === 3) {
        return '已完成'
      }
    },
    formatTime(row, column, cellValue, index) {
      if (this.$route.path === '/chat') {
        var date = new Date(cellValue)
        return (date.getMonth() + 1) + '月' + date.getDate() + '日'
      } else {
        return cellValue
      }
    },
    hideOrderPage(data) {
      if (data) {
        this.getOrders()
      }
      this.showOrderPage = false
      this.showOrderList = true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.name !== 'finished' && from.path === '/chatlog') {
      next(vm => {
        vm.showOrderList = false
        vm.showOrderPage = true
      })
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-pagination {
  text-align: right;
  margin-top:10px
}

.block{
    display: inline-block;
    position: relative;
}

.block:after{
    content: "";
    position: absolute;
    left: 0;
    bottom: -11px;
    width: 110%;
    height: 1px;
    background-color: #337eff;
}

.header {
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
}
</style>
